import { walk } from '../utils';
export function matches(html) {
  return /data-slate-/.test(html);
}

// The Slate text editor frame work (https://github.com/ianstormtaylor/slate) is used by Zendesk
// It represents empty lines as <span data-slate-zero-width="n">&#65279;</span>
// Converting these to <p> ensures we represent them properly when pasted
export function clean(root) {
  let nodesToSkip = ['UL', 'OL'];
  walk(root, nodesToSkip, node => {
    if (node.nodeName === 'SPAN' && node.getAttribute('data-slate-zero-width') === 'n') {
      node.parentNode?.replaceChild(document.createElement('p'), node);
    }
  });
  return root;
}